






















import { mapActions, mapState } from 'vuex';
import { checkPrimaryDiff, getID } from '@adobe/edex/frontend/views/course/settings/constants';

export default {
  props: {
    metaDataName: {
      required: true,
      type: String,
    },
    labelAccess: {
      required: true,
      type: String,
    },
    initialSelected: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
    },
  },
  data() {
    return {
      filter: '',
      show: false,
      selected: this.initialSelected,
    };
  },
  computed: {
    ...mapState('course', ['course']),
    metaData() {
      return this.data
        ? this.data
        : this.$store.state.metadata[this.metaDataName];
    },
    filteredList() {
      if (this.filter) {
        return this.metaData.filter(item =>
          this.$t(item[this.labelAccess])
            .slice(0, this.filter.length)
            .toLowerCase()
            .includes(this.filter.toLowerCase())
        );
      } else {
        return this.metaData;
      }
    },
    selectedIDs() {
      return this.selected.map(getID);
    },
  },
  async created() {
    if (!this.metaData) {
      await this.fetchByType(this.metaDataName);
    }
  },
  watch: {
    initialSelected(current, prev) {
      if (
        checkPrimaryDiff(current, prev) &&
        checkPrimaryDiff(current, this.selected)
      ) {
        this.filter = '';
        this.show = false;
        this.selected = current;
      }
    },
  },
  methods: {
    ...mapActions('metadata', ['fetchByType']),
    handleSelect(data) {
      if (this.selectedIDs.includes(data.id)) {
        this.selected = this.selected.filter(item => item.id !== data.id);
      } else {
        this.selected = [...this.selected, data];
      }
    },
    handleClose() {
      this.$emit('onMetaChanged', {
        data: this.selected,
        name: this.metaDataName,
      });

      this.show = false;
    },
  },
};
